module.exports = __webpack_public_path__ + "assets/images/project/solar-eclipse-header-desktop.jpg?v=bb71ce33";